import { useEffect, useState } from 'react'
import CloseSvg from '../assets/img/svg/close'
import SaveSvg from '../assets/img/svg/save'
import API from '../hooks/requests'
import FormWebhook from '../enties/form-webhook'
import StopSvg from '../assets/img/svg/stop'

const CreateWebhook = ({
  createWebhook,
  pipelineGet,
  setPipelineGet,
  pipelineNameGet,
  setPipelineNameGet,
  keyGet,
  setKeyGet,
  close,
  toast,
  setDataList,
}) => {
  const [load, setLoad] = useState(false)
  const [optPipeline, setOptPipeline] = useState([])

  useEffect(() => {
    setLoad(true)
    if (createWebhook) {
      API.getPipelineList().then((r) => {
        setOptPipeline(r.data.data)
        setLoad(false)
      })
    }
  }, [createWebhook])

  return (
    <div className="modal-column">
      <div className="modal-topbar">
        <div className="modal-close" onClick={close}>
          <CloseSvg />
          <span>Back to list</span>
        </div>
        <div
          className="modal-save"
          onClick={() => {
            if (pipelineGet) {
              API.postWebhook({
                key: keyGet,
                pipeline: pipelineGet,
                name: pipelineNameGet,
              })
                .then(() => {
                  close()
                  API.getWebhooksList()
                    .then((r) => {
                      setDataList(r.data.data)
                    })
                    .catch((e) => console.log(e))
                })
                .catch((e) => {
                  if (
                    e.status === 400 &&
                    e.response.data.msg === 'Key is already in use'
                  ) {
                    toast(
                      <span className="notify_-copy-link">
                        <StopSvg />
                        <span>Key is already in use!</span>
                      </span>
                    )
                  }
                })
            } else {
              toast(
                <span className="notify_-copy-link">
                  <StopSvg />
                  <span>Pipeline not selected!</span>
                </span>
              )
            }
          }}
        >
          <SaveSvg />
        </div>
      </div>
      {load ? (
        <div className="load-data">Getting data from pipelines...</div>
      ) : (
        <div className="create-bundle-webhook">
          <FormWebhook
            pipeline={pipelineGet}
            keyGet={keyGet}
            optPipeline={optPipeline}
            callback={(e) => {
              setPipelineGet(e.value)
              setPipelineNameGet(e.label)
            }}
            keyCallback={(e) => setKeyGet(e.target.value)}
          />
        </div>
      )}
    </div>
  )
}

export default CreateWebhook
